import { useEffect, useState } from "react";
import { Languages, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function TranslateCatalogButton() {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const loadStatus = () => api.get("/admin/translate-catalog/status").then((r) => setStatus(r.data)).catch(() => {});
  useEffect(() => { loadStatus(); }, []);

  const run = async () => {
    setBusy(true);
    try {
      const r = await api.post("/admin/translate-catalog");
      toast.success(`Traducere pornită pentru ${r.data.queued} produse (rulează în fundal).`);
      setTimeout(loadStatus, 4000);
    } catch { toast.error("Eroare la pornirea traducerii."); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-2">
      {status && (
        <span className="text-xs text-slate-500" data-testid="translate-status">
          {status.translated}/{status.total} traduse
        </span>
      )}
      <button onClick={run} disabled={busy} className="inline-flex items-center gap-2 border border-slate-300 hover:border-orange-600 hover:text-orange-600 px-3 py-2 text-sm font-bold uppercase tracking-wide transition-colors disabled:opacity-50" data-testid="translate-catalog-btn">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Languages className="w-4 h-4" />} Traducere catalog
      </button>
    </div>
  );
}
